// extracted by mini-css-extract-plugin
module.exports = {"cardListWrap":"CardPokemon_cardListWrap__2EeSI","appear":"CardPokemon_appear__1OyAg","typesWrap":"CardPokemon_typesWrap__3Ad-J","type":"CardPokemon_type__1evg1"};